/*
 * @Author: Zhouqi
 * @Date: 2025-10-29 17:19:50
 * @LastEditors: Zhouqi
 * @LastEditTime: 2025-12-17 11:54:01
 */
import dynamic from 'next/dynamic';
import React, { memo, useLayoutEffect } from 'react';

import DelayedRender from '../DelayRender';
import DisplayHeader from './display-header';
import MenuSkeleton from './left-menu/MenuSkeleton';
// import InviteFriends from './inviteFriends';
import LogoIcon from './logo';
import styles from './style.module.scss';

interface indexProps {
  children: React.ReactNode;
}

const LeftMenu = dynamic(() => import('./left-menu'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <MenuSkeleton />
    </DelayedRender>
  ),
});

const Layout: React.FC<indexProps> = memo((props) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = React.useState(56);

  useLayoutEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);

  return (
    <div className="w-full h-full overflow-hidden">
      <div className="flex-1 w-full h-full min-w-[1200px] bg-no-repeat bg-center bg-cover overflow-hidden">
        <div className="flex w-full h-full overflow-hidden pl-[222px]">
          <div className={styles['left-menu']}>
            <LogoIcon />
            <LeftMenu />
            {/* <InviteFriends /> */}
          </div>
          <div className="flex-1 overflow-hidden">
            <DisplayHeader ref={headerRef} />
            <div
              style={{
                height: `calc(100vh - ${headerHeight}px)`,
              }}
            >
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

Layout.displayName = 'Layout';

export default Layout;
